<template>
  <div class="flex items-center cursor-pointer justify-end lg:justify-start" @click="onClickHide">
    <div class="mr-2 flex items-center">
      <v-icon name="angle-double-right" class="text-brand" />
    </div>
    <div class="text-grey-darkest text-sm">Klik untuk menyembunyikan</div>
  </div>
</template>

<script>
export default {
  name: 'hide-modal-button',
  props: {
    onClickHide: Function
  }
}
</script>
